module.exports = __webpack_public_path__ + "static/img/Bachelor_010547.a84482a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010547.jpg
// module id = 186
// module chunks = 0